import { ENDPOINT_BASE } from '@/config/endpoints'

export const ENDPOINT_SUBSCRIPTIONS = `${ENDPOINT_BASE}/subscriptions`
